// src/controllers/bancoController.js

import { getBancos, createBanco, updateBanco, deleteBanco } from '../models/bancoModel';
import Swal from 'sweetalert2';
import pb from '../lib/pocketbase';
import { toasts }  from "svelte-toasts";

export async function fetchBancos(page, perPage) {
  try {
    const response = await getBancos(page, perPage);
    return {
      bancos: response.items,
      totalRecords: response.totalItems,
      currentPage: response.page,
    };
  } catch (error) {
    console.error("Error fetching bancos:", error);
    Swal.fire('Error', 'No se pudieron cargar los bancos', 'error');
    return null;
  }
}

export async function saveBanco(banco, currentBancoId) {
  try {
    if (currentBancoId) {
      await updateBanco(currentBancoId, banco);
      toasts.add({
        title: 'Éxito',
        description: 'Banco guardado exitosamente',
        duration: 3000, // Duración de 3 segundos
        placement: 'bottom-right',
        type: 'success',
        theme: 'dark',
        showProgress: true
      });
    } else {
      await createBanco(banco);
      toasts.add({
        title: 'Éxito',
        description: 'Banco creado exitosamente',
        duration: 3000, // Duración de 3 segundos
        placement: 'bottom-right',
        type: 'success',
        theme: 'dark',
        showProgress: true
      });
    }
  } catch (error) {
    console.error("Error saving banco:", error);
    toasts.add({
      title: 'Error',
      description: 'Ocurrió un error al guardar el banco',
      duration: 3000,
      placement: 'bottom-right',
      type: 'error',
      theme: 'dark',
      showProgress: true
    });
  }
}

export async function removeBanco(id) {
  try {
    await deleteBanco(id);
    toasts.add({
      title: 'Éxito',
      description: 'Banco eliminado exitosamente.',
      duration: 3000,
      placement: 'bottom-right',
      type: 'error',
      theme: 'dark',
      showProgress: true
    });
  } catch (error) {
    console.error("Error deleting banco:", error);
    Swal.fire('Error', 'No se pudo eliminar el banco', 'error');
  }
}


// Suscripción en tiempo real a cambios en la colección 'banco'
export function subscribeToBancos(searchQuery, handleSearch) {
  pb.collection('banco').subscribe('*', async (e) => {
    // `e` contiene la información del cambio: tipo, nuevo valor, etc.
    console.log('Evento en tiempo real recibido:', e);

    // Llamar a la función de búsqueda con la consulta actual
    await handleSearch(); // Actualiza la lista manteniendo la página actual
  });
}

// Desuscripción de los eventos en tiempo real
export function unsubscribeFromBancos() {
  pb.collection('banco').unsubscribe('*');
}

export async function searchBancos(query, page = 1, perPage = 10) {
  // Replace with your actual PocketBase querying logic
  const response = await pb.collection('banco').getList(page, perPage, {
    filter: `descrip ~ "${query}"`,
  });
  return {
    bancos: response.items,
    totalRecords: response.totalItems,
    currentPage: response.currentPage,
  };
}
